import { Product } from "@omni/types/api/product/bff/product.model";
import { ProductFieldSet } from "@omni/types/api/product/bff/shared/enums/productFieldSet.enum";
import classNames from "classnames";

import { ProductBundleModel } from "@/api/mappers/productBundles.mapper";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

import { ProductBundle } from "./components/ProductBundle/productBundle.container";

const getKey = (bundle: ProductBundleModel) => {
    return bundle.bundleProducts
        .map((bundleProduct) => bundleProduct.product.sku)
        .join("-");
};

type ProductBundlesComponent = {
    mainProduct: Product<ProductFieldSet.ProductTile>;
    productBundles: Array<ProductBundleModel>;
    className?: string;
};

export const ProductBundlesComponent = ({
    mainProduct,
    productBundles,
    className
}: ProductBundlesComponent) => {
    const { t } = useGranite();

    return (
        <article className={classNames("productBundle", className)}>
            <h2> {t("general.productBundles.title")}</h2>
            {productBundles.map((productBundle) => (
                <ProductBundle
                    key={getKey(productBundle)}
                    mainProduct={mainProduct}
                    productBundle={productBundle}
                />
            ))}
        </article>
    );
};
